var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-virtual"},[_c('button',{staticClass:"popup-virtual__open",on:{"click":function($event){return _vm.gotoLink(_vm.link)}}},[_vm._v("\n    "+_vm._s(_vm.translate('Virtuaaliesittely'))+"\n\n    "),_c('div',{staticClass:"popup-virtual__open-icon",class:`popup-virtual__open-icon--${_vm.color}`},[_c('ChevronIcon')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }